import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_close_big.png';

const _withScopeId = n => (_pushScopeId("data-v-7cc9f3f1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "cms-card-block"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2,
  style: {
    "width": "100%"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_10 = {
  key: 3,
  style: {
    "display": "flex"
  }
};
const _hoisted_11 = {
  key: 0,
  class: "video_dialog"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_13 = [_hoisted_12];
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import CheckDetailInfo from '@/views/onDemandContent/FilmReview/Check/index.vue';
import MediaPlay from '@/views/onDemandContent/Components/MediaPlay/index.vue';
import Uploader from 'simple-uploader.js';
import { getMediaDetailApi } from '@/api/mediaManagement';
import { clearData } from '@/utils/tools';
import { useCommon } from '@/store/useCommon';
import { useI18n } from 'vue-i18n';
import { getCurrentTime } from '@/utils/timeFormat';
import { getTextWidth } from '@/utils';
import { useBroadCastList } from '@/utils/cacheData';
import { handleCopy } from '@/utils/clipboard';
export default /*#__PURE__*/_defineComponent({
  __name: 'mediaDetail',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: {
        id: ''
      }
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const transcodeColorObj = {
      0: '#4ea8fa',
      1: '#29b87d',
      2: '#f2994a'
    }; // 标题配置

    const headerConfig = reactive({
      title: '详情',
      btnList: [{
        label: '返回',
        func: () => {
          emit('update:modelValue', false);
          emit('update-list');
        }
      }]
    });
    const formConfig = reactive({
      formList: [[{
        label: '文件名称',
        prop: 'fileName',
        widgetType: 'text'
      }, {
        label: '类型',
        prop: 'fileType',
        widgetType: 'text',
        formatter: val => val && val.toLowerCase()
      }], [{
        label: '文件大小',
        prop: 'fileSize',
        widgetType: 'text',
        formatter: val => {
          return val && Uploader.utils.formatSize(val);
        }
      }, {
        label: '上传用户',
        prop: 'userName',
        widgetType: 'text'
      }], [{
        label: '上传时间',
        prop: 'createTime',
        widgetType: 'text',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '是否转码',
        prop: 'transcodeStatus',
        widgetType: 'text',
        itemSlot: true
      }], [{
        label: '关联影片',
        prop: 'programName',
        widgetType: 'text',
        itemSlot: true
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        widgetType: 'text'
      }], [{
        label: 'URL',
        prop: 'fileUrl',
        widgetType: 'text',
        colspan: 3,
        itemSlot: true
      }], [{
        label: '转码URL',
        prop: 'transcodeUrl',
        widgetType: 'text',
        colspan: 3,
        itemSlot: true
      }]],
      formData: {
        fileName: '',
        fileType: '',
        fileSize: '',
        userName: '',
        createTime: '',
        transcodeStatus: '',
        programName: '',
        sourceId: '',
        fileUrl: '',
        transcodeUrl: '',
        programId: '',
        programType: 0
      }
    });
    const isLoading = ref(false);
    const showVideo = ref(false);

    const showVideoDialog = () => {
      setTimeout(() => {
        showVideo.value = true;
      }, 100);
    };

    const getMediaDetail = async () => {
      isLoading.value = true;

      try {
        const res = await getMediaDetailApi({
          id: props.detailInfo.id
        });

        if (res.code == '0') {
          formConfig.formData = res.data;
          tableConfig.data = res.data.transcodeUrl ? JSON.parse(res.data.transcodeUrl.replace(/'/g, '"')) : [];

          if (res.data && res.data.sourceId) {
            formConfig.formData.sourceId = res.data.sourceId ? res.data.sourceId + ` (${res.data.sourceId.includes('tt') ? 'IMDB' : res.data.sourceId.includes('ar') ? 'ARAB' : 'TMDB'})` : '';
          }
        }
      } catch (error) {
        console.log(error);
      }

      isLoading.value = false;
    };

    const showCheckDetailInfo = ref(false);
    const cid = ref(useCommon().userData.cid[0] || 0);
    const checkDetailParams = reactive({
      id: '',
      programType: 0
    });

    const toCheckDetailInfo = () => {
      checkDetailParams.id = formConfig.formData.programId;
      checkDetailParams.programType = formConfig.formData.programType;
      showCheckDetailInfo.value = true;
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      isShowHeader: false
    });
    const columnConfig = reactive({
      columnList: [{
        label: '编码标准',
        prop: 'videoCode',
        formatter: val => {
          return val === 0 ? 'H.264' : 'H.265';
        },
        width: 130
      }, {
        label: '分辨率',
        prop: 'type',
        formatter: val => {
          if (val) {
            return getRatioType(val);
          }
        },
        width: 130
      }, {
        label: 'URL',
        prop: 'fileUrl',
        cellSlot: true,
        showOverflowTooltip: false
      }]
    }); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width + 80;
    };

    const displayTextTip = () => {
      tipDisabled.value = false;
      return;
    }; // 格式化分辨率显示文字


    const getRatioType = val => {
      const item = broadCastList.value.filter(item => {
        return item.type === val;
      });
      return item && item.length && item[0].broadCastType;
    };

    const broadCastList = ref([]); // 获取分辨率

    const getBroadCastList = async () => {
      const res = await useBroadCastList();
      broadCastList.value = res;
    }; // 复制URL


    const copyUrl = (url, event, className) => {
      if (className) {
        let target = document.querySelector('.' + className);
        const width = getTextWidth(target.innerText, {
          fontSize: '14px'
        });
        if (target.offsetWidth < width + 80) return;
      }

      handleCopy(url, event);
    };

    watch(() => props.modelValue, val => {
      if (val) {
        if (props.detailInfo.id) {
          getBroadCastList();
          getMediaDetail();
        }
      } else {
        clearData(formConfig.formData);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [!showCheckDetailInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_FormTable, {
        style: {
          "margin-bottom": "30px"
        },
        col: ['15%', '35%', '15%', '35%']
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, item => {
          return _openBlock(), _createBlock(_component_FormItem, {
            "form-item": item,
            "form-data": formConfig.formData
          }, {
            itemSlot: _withCtx(scope => [scope.prop == 'fileUrl' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", {
              class: "link",
              onClick: showVideoDialog
            }, _toDisplayString(formConfig.formData.fileUrl), 1)])) : _createCommentVNode("", true), scope.prop == 'programName' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", {
              class: "link",
              onClick: toCheckDetailInfo
            }, _toDisplayString(formConfig.formData.programName), 1)])) : _createCommentVNode("", true), scope.prop == 'transcodeUrl' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [formConfig.formData.transcodeUrl ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_common_table, {
              style: {
                "width": "100%"
              },
              showPagination: false,
              "table-config": tableConfig
            }, {
              default: _withCtx(() => [_createVNode(_component_column, {
                "column-list": columnConfig.columnList
              }, {
                cellSlot: _withCtx(scope => [scope.column.property == 'fileUrl' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_MPopper, {
                  disabled: tipDisabled.value,
                  placement: "top",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [_createElementVNode("div", {
                    onMouseover: showTextTip,
                    class: _normalizeClass('url-span-' + scope.row.index),
                    style: {
                      "display": "inline-block",
                      "white-space": "nowrap",
                      "width": "100%",
                      "overflow": "hidden",
                      "text-overflow": "ellipsis"
                    }
                  }, [_createElementVNode("span", null, _toDisplayString(scope.row.fileUrl), 1), scope.row.fileUrl ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onMouseover: _withModifiers(displayTextTip, ["stop"]),
                    class: "cms-op-btn-non-focus",
                    onClick: $event => copyUrl(scope.row.fileUrl, $event, 'url-span-' + scope.row.index),
                    style: {
                      "width": "60px",
                      "margin-left": "20px"
                    }
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
                    _: 2
                  }, 1032, ["onMouseover", "onClick"])) : _createCommentVNode("", true)], 34)]),
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, _toDisplayString(scope.row.fileUrl), 1), _createVNode(_component_el_button, {
                    class: "cms-op-btn-non-focus",
                    onClick: $event => copyUrl(scope.row.fileUrl, $event),
                    style: {
                      "margin-left": "20px"
                    }
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
                    _: 2
                  }, 1032, ["onClick"])])]),
                  _: 2
                }, 1032, ["disabled"])])) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["column-list"])]),
              _: 2
            }, 1032, ["table-config"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.prop == 'transcodeStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", {
              style: _normalizeStyle(['color:' + transcodeColorObj[formConfig.formData.transcodeStatus], {
                "display": "inline-block",
                "width": "100%",
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              }])
            }, _toDisplayString(formConfig.formData.transcodeStatus == '0' ? _unref(t)('未转码') : formConfig.formData.transcodeStatus == '1' ? _unref(t)('已转码') : formConfig.formData.transcodeStatus == '2' ? _unref(t)('转码中') : formConfig.formData.transcodeStatus == '3' ? _unref(t)('无需转码') : '--'), 5)])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["form-item", "form-data"]);
        }), 256))]),
        _: 1
      })])), [[_directive_loading, isLoading.value]]), showVideo.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("article", null, [_createVNode(MediaPlay, {
        url: formConfig.formData.fileUrl,
        style: {
          "width": "800px",
          "height": "525px"
        }
      }, null, 8, ["url"]), _createElementVNode("div", {
        class: "video__close",
        onClick: _cache[0] || (_cache[0] = $event => showVideo.value = false)
      }, _hoisted_13)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(CheckDetailInfo, {
        modelValue: showCheckDetailInfo.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showCheckDetailInfo.value = $event),
        "detail-info": checkDetailParams,
        showAuditStatus: false,
        "header-title": "查看",
        cid: cid.value,
        onUpdateList: _cache[2] || (_cache[2] = () => {})
      }, null, 8, ["modelValue", "detail-info", "cid"])])) : _createCommentVNode("", true);
    };
  }

});